const BoardButton = (props) => {
    return (
        <button className={`button confirm ${props.className}`} type={props.type || "button"} title="Vis timer" disabled={props.disabled} onClick={props.onClick}>
            {props.children}
        </button>
    );
};

export default BoardButton;